import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTheme } from 'emotion-theming';
import { Theme } from '@/theme';

type Props = {
  to: string;
  exact?: boolean;
  collapsed?: boolean;
  isSection?: boolean;
  children?: React.ReactNode;
  style?: React.CSSProperties;
};

const SidebarLink = ({
  to,
  exact,
  collapsed,
  isSection,
  children,
  style,
}: Props): JSX.Element => {
  const theme = useTheme<Theme>();

  const baseStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: theme.space[2],
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    transition: 'all .2s ease',
    borderLeft: '3px solid transparent',
    ...(isSection
      ? {
          padding: `${theme.space[2]}px ${theme.space[3]}px`,
          paddingLeft: `calc(${theme.space[3]}px - 3px)`,
          color: theme.colors.base.gray[500],
          fontSize: theme.fontSizes[1],
          fontWeight: theme.fontWeights.heading,
          textTransform: 'uppercase' as const,
          letterSpacing: '0.06em',
          justifyContent: collapsed ? 'center' : undefined,
        }
      : {
          paddingTop: theme.space[1],
          paddingBottom: theme.space[1],
          paddingLeft: theme.space[7],
          paddingRight: theme.space[3],
          color: theme.colors.onNavbar,
          fontSize: theme.fontSizes[2],
          fontWeight: theme.fontWeights.body,
          lineHeight: '1.4',
        }),
    ...style,
  };

  return (
    <NavLink
      to={to}
      exact={exact}
      style={baseStyle}
      activeStyle={{
        color: theme.colors.onNavbarHover,
        borderLeftColor: theme.colors.navbarHover,
        backgroundColor: theme.colors.base.gray[100],
      }}
    >
      {children}
    </NavLink>
  );
};

export default SidebarLink;
